export class SaveRelatedCourseData{
  pathwayInstitutionId: any = null;
  pathwayStudyLevelId: any = null;
  pathwayQualificationTypeGroupId: any = null;
  pathwayQualificationTypeId: any = null;
  pathwayCourseInstanceId: any = null;
  pathwayTypeId: any = null;
  createdBy?: any;
  updatedBy?: any;
}